import createCache from '@emotion/cache';

// speedy: false forza Emotion a inserire le regole CSS come TESTO dentro i
// tag <style>, invece che via CSSOM (insertRule) — il default in
// produzione ("modalita' speedy"), piu' veloce per gli utenti reali.
//
// Perche' NON lo disattiviamo per tutti: agli utenti reali non importa se
// il testo compare nel tag <style>, gli basta che lo stile sia applicato —
// e insertRule lo applica correttamente e piu' in fretta. Disattivare
// speedy sempre pagherebbe un costo di performance ad ogni visita senza
// alcun beneficio per il 99% del traffico.
//
// A chi serve davvero: solo a scripts/prerender.cjs, che cattura l'HTML
// con Puppeteer (page.content()) per scrivere le pagine statiche su disco.
// page.content() serializza il DOM cosi' com'e' — in modalita' speedy le
// regole iniettate via insertRule non compaiono nel textContent del tag
// <style>, quindi l'HTML statico salvato ha i tag <style data-emotion="...">
// vuoti pur avendo gia' tutte le classi Chakra (css-xxxx) applicate nel
// markup. Un utente reale scarica quell'HTML PRIMA che il bundle JS carichi
// e idrati: per una frazione di secondo vede il markup completo ma senza le
// regole CSS dei componenti Chakra (solo main.css, che non le contiene) —
// e' esattamente il flash di CSS/HTML "strano" segnalato.
//
// Fix mirato: disattiviamo speedy SOLO quando la pagina gira dentro
// Puppeteer durante il prerendering, riconoscendolo tramite lo stesso
// escape hatch gia' usato in src/firebase.js (riga 37) per lo stesso scopo:
// prerender.cjs imposta navigator.userAgent = 'ReactSnap' apposta per
// questo. Per tutti gli altri visitatori il comportamento resta invariato
// (speedy: true, il default veloce di produzione).
const isPrerenderCapture =
    typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const emotionCache = createCache({ key: 'css', speedy: !isPrerenderCapture });

export default emotionCache;
